{
  "page_count": "από {n, plural, one{# σελίδα} other{# σελίδες}}"
}
